import * as React from 'react';

import { QuestionScore } from '~teacher/models/activities';

interface ProviderProps {
  children?: React.ReactNode;
  questionScores: Record<string, QuestionScore>;
}

interface ActivityData {
  questionScores: Record<string, QuestionScore>;
}

const ActivityContext = React.createContext<ActivityData>(null);

/**
 * A simple context hook to return activity data provided by
 * `ActivityResultProvider`.
 *
 * @see ActivityResultProvider
 */
export function useResultState() {
  const context = React.useContext(ActivityContext);

  if (context === undefined) {
    throw new Error(
      'useResultState must be used within ActivityResultProvider'
    );
  }

  return context;
}

/**
 * Provides parsed and normalised Activity data to child components.
 */
export function ActivityResultProvider(props: ProviderProps) {
  const activityData = {
    questionScores: props.questionScores,
  };

  return (
    <ActivityContext.Provider value={activityData}>
      {props.children}
    </ActivityContext.Provider>
  );
}
